angular.module("KhBase").factory('PlatformSettingsFactory', ['$resource', function ($resource) {
    return $resource('api/v1.0/khutils/platformsettings/');
}]);
